import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

/*
  (중요) API 요청 인터셉터
  - 앞으로 모든 API 요청 헤더에 자동으로 JWT 토큰을 추가해줍니다.
*/
api.interceptors.request.use(
  (config) => {
    // ⬇️ [수정] localStorage -> sessionStorage에서 토큰을 가져옵니다.
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
  API 응답 인터셉터
  - 에러 응답을 안전하게 처리하여 payload 관련 에러를 방지합니다.
*/
api.interceptors.response.use(
  (response) => {
    // 정상 응답은 그대로 반환
    return response;
  },
  (error) => {
    // 에러 응답을 안전하게 처리
    // Edge 브라우저에서 undefined.payload 에러 방지
    if (error && !error.response) {
      // 네트워크 에러 등 response가 없는 경우
      return Promise.reject({
        ...error,
        response: {
          data: {
            message: '네트워크 오류가 발생했습니다. 연결을 확인해주세요.'
          },
          status: 0
        }
      });
    }
    if (error.response && error.response.status === 504) {
      return Promise.reject({
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response?.data,
            message: '서버 응답 시간이 초과되었습니다. 복원이나 백업이 서버에서 계속 진행 중일 수 있습니다. 잠시 후 페이지를 새로고침하세요. 다시 복원을 누르지 마세요.',
          },
        },
      });
    }
    if (error.response && error.response.status === 503) {
      return Promise.reject({
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response?.data,
            message: error.response?.data?.message || '데이터 복원 중입니다. 잠시 후 다시 시도하세요.',
          },
        },
      });
    }
    // 502 Bad Gateway: 백엔드 서버 연결 실패
    if (error.response && error.response.status === 502) {
      return Promise.reject({
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response?.data,
            message: '서버에 연결할 수 없습니다. (502 Bad Gateway) 백엔드 서버가 실행 중인지 확인해 주세요.'
          }
        }
      });
    }
    return Promise.reject(error);
  }
);

export default api;
